import styled from '@emotion/styled';

export const BadgeContent = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 4,
}));
